/**
 * Device Fingerprinting for Security
 * Generates a unique identifier for the device
 */

export async function generateFingerprint(): Promise<string> {
  const components = [
    navigator.userAgent,
    navigator.language,
    new Date().getTimezoneOffset(),
    screen.width,
    screen.height,
    screen.colorDepth,
  ];

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (ctx) {
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Digital Palengke', 2, 2);
    components.push(canvas.toDataURL());
  }

  const fingerprint = components.join('|');

  // Simple hash function
  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  return Math.abs(hash).toString(36);
}

let cachedFingerprint: string | null = null;

export async function getFingerprint(): Promise<string> {
  if (!cachedFingerprint) {
    cachedFingerprint = await generateFingerprint();
  }
  return cachedFingerprint;
}


















